var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 21.0013C7.15442 21.0013 3.21143 17.0583 3.21143 12.2123C3.21143 9.55625 4.39843 7.06725 6.46843 5.38325C6.89643 5.03325 7.52643 5.09925 7.87543 5.52725C8.22343 5.95625 8.15943 6.58525 7.73043 6.93425C6.12943 8.23625 5.21143 10.1603 5.21143 12.2123C5.21143 15.9563 8.25742 19.0013 12.0004 19.0013C15.7434 19.0013 18.7884 15.9563 18.7884 12.2123C18.7884 10.1603 17.8704 8.23625 16.2704 6.93425C15.8414 6.58525 15.7764 5.95625 16.1254 5.52725C16.4744 5.09925 17.1044 5.03425 17.5314 5.38225C19.6014 7.06625 20.7884 9.55525 20.7884 12.2123C20.7884 17.0583 16.8464 21.0013 12.0004 21.0013Z",
    fill: "#FF2626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 11.787C11.4484 11.787 11.0004 11.339 11.0004 10.787V4C11.0004 3.448 11.4484 3 12.0004 3C12.5524 3 13.0004 3.448 13.0004 4V10.787C13.0004 11.339 12.5524 11.787 12.0004 11.787Z",
    fill: "#FF2626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerButton);
export default __webpack_public_path__ + "static/media/power-button.44c0d9a02e9d360bd50820f28ad57930.svg";
export { ForwardRef as ReactComponent };